export function formatDate(date: Date) {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
  };
  if (date) {
    return date.toLocaleDateString('ru-RU', options);
  } else {
    const today = new Date();
    return today.toLocaleDateString('ru-RU', options);
  }
}
